<template>
    <footer>
		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-4 col-md-3">
					<div class="logo">
						<router-link :to="'/' + $route.params.lang" class="logo"><img src="@/assets/logo-square.png" alt="Professional be Positive" title="Professional be Positive" /></router-link>
					</div>
				</div>
				<div class="col-12 col-sm-4 col-md-3">
					<div class="menu">
						<router-link :to="'/' + $route.params.lang">{{ $PPlusEngine.getDictionary($route.params.lang, 'หน้าแรก', 'Home') }}</router-link>
						<router-link :to="'/' + $route.params.lang + '/course'">{{ $PPlusEngine.getDictionary($route.params.lang, 'คอร์สเรียน', 'Courses') }}</router-link>
						<router-link :to="'/' + $route.params.lang + '/exam'">{{ $PPlusEngine.getDictionary($route.params.lang, 'สอบวัดผล', 'Exam') }}</router-link>
                        <router-link :to="'/' + $route.params.lang + '/payment'">{{ $PPlusEngine.getDictionary($route.params.lang, 'การชำระเงิน', 'Payment') }}</router-link>
                        <router-link :to="'/' + $route.params.lang + '/why'">{{ $PPlusEngine.getDictionary($route.params.lang, 'ทำไมต้องเรียน?', 'Why need to learn?') }}</router-link>
					</div>
				</div>
				<div class="col-12 col-sm-4 col-md-3">
					<div class="menu">
                        <router-link :to="'/' + $route.params.lang + '/about'">{{ $PPlusEngine.getDictionary($route.params.lang, 'เกี่ยวกับเรา', 'About Us') }}</router-link>
						<router-link :to="'/' + $route.params.lang + '/contact'">{{ $PPlusEngine.getDictionary($route.params.lang, 'ติดต่อเรา', 'Contact Us') }}</router-link>
						<router-link :to="'/' + $route.params.lang + '/term'">{{ $PPlusEngine.getDictionary($route.params.lang, 'ข้อกำหนดการใช้งาน', 'Terms and Agreements') }}</router-link>
						<router-link :to="'/' + $route.params.lang + '/privacy'">{{ $PPlusEngine.getDictionary($route.params.lang, 'นโยบายความเป็นส่วนตัว', 'Privacy Policy') }}</router-link>
					</div>
				</div>
				<div class="col-12 col-md-3">
					<div class="social">
						<a href="https://www.facebook.com/ProfessionalBePositive" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-f']" /></a>
					</div>
                    <div class="contact">
                        <font-awesome-icon :icon="['fas', 'phone']" /> TEL: 06-5617-6123
                    </div>
                    <div class="contact">
                        <font-awesome-icon :icon="['fas', 'envelope']" /> support@probplus.com
                    </div>
				</div>
			</div>
			<div class="copyright">Copyright © 2020 Professional be Positive</div>
		</div>
	</footer>
</template>

<script>
export default {
    props: {
        fields: Object
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #333;
    padding: 30px 0 40px;

    @media only screen and (max-width: $screenMedium) {
        position: static;
    }

    .logo {
        @media only screen and (max-width: $screenSmall) {
            padding-bottom: 20px;
            text-align: center;
        }

        img {
            display: inline-block;
            max-width: 100%;
        }
    }

    .menu {
        @media only screen and (max-width: $screenSmall) {
            text-align: center;
        }

        a {
            display: block;
            color: #ccc;
            margin-top: 10px;
            font-size: 15px;
        }
    }

    .social {
        text-align: right;
        padding-bottom: 20px;

        @media only screen and (max-width: $screenMedium) {
            padding-top: 30px;
            text-align: center;
        }

        a {
            @include verticalAlign(top);
            @include borderRadius(1000px);
            width: 40px;
            height: 40px;
            background: #666;
            font-size: 21px;
            color: #fff;
            text-align: center;
            padding-top: 5px;
            margin-left: 5px;

            @media only screen and (max-width: $screenSmall) {
                margin: 0 5px;
            }

            &:hover {
                @include rotateText(360deg);
            }
        }
    }

    .contact {
        text-align: right;
        margin: 3px 0;
        font-size: 12px;
        color: #ccc;

         @media only screen and (max-width: $screenSmall) {
            text-align: center;
        }

        svg {
            margin-right: 10px;
        }
    }

    .copyright {
        margin-top: 40px;
        padding-top: 20px;
        text-align: center;
        border-top: 1px solid #555;
        color: #999;
        font-size: 12px;
    }
}
</style>